module.exports = __webpack_public_path__ + "img/wesettle.f447212a.png";